import Vue from 'vue'
import { executePromiseTask } from 'firepuma-vue-axios-vuex-extensions/vuex-store/helpers';
import { BroilerAdminAPI } from '@/broilerAdmin/store/_api.js';

export default {
  namespaced: true,

  state: {
    alerts: [],
  },

  mutations: {
    SetAlerts: (state, alerts) => {
      Vue.set(state, 'alerts', alerts);
    },
    RemoveAlert: (state, alert) => {
      let idx = state.alerts.findIndex(x => x.id === alert.id);
      if (idx === -1) return;
      state.alerts.splice(idx, 1);
    },
  },

  actions: {
    LOAD_ADMIN_ALERTS(context) {
      let taskName = `LOAD_ADMIN_ALERTS`;
      return executePromiseTask(
        taskName,
        context,
        () => BroilerAdminAPI.listAlerts()
      ).then(alerts => {
        context.commit('SetAlerts', alerts);
        return alerts;
      });
    },
  },
}



// WEBPACK FOOTER //
// ./src/broilerAdmin/store/alerts.js